import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { homeRoute } from '@app-constants/app.constants';
import { environment } from '@app-environments/environment';
import { AuthService } from '@app-services/auth-service/auth.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { isUserAdmin, setLoggedInUserData } from 'src/app/helpers/functions';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css', '../payment/payment.component.css']
})
export class OtpComponent implements OnInit {
  otpForm!: FormGroup
  counter
  optErr = false
  resendOtpBtn = true
  otpValid = false
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,

    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  navExtras
  userData
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;

  constructor(private location: Location, private router: Router,
    private formBuilder: FormBuilder,
    private signUpService: SignupService,
    private userService: UserService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private gaService: GAnalyticsService
  ) { }

  ngOnInit(): void {
    this.navExtras = this.location.getState()
    if (!Object.keys(this.navExtras).length) {
      window.location.href = homeRoute
    }
    this.otpForm = this.formBuilder.group({
      otp: [null],
    });
    this.userData = JSON.parse(localStorage.getItem('logData'));
    this.startCountdown(60)
  }
  onOtpChange(event: any) {
    // this.ngOtpInputRef.setValue(event);//yourvalue can be any string or number eg. 1234 or '1234'
    if (event.length === 4) {
      this.otpForm.get('otp')?.setValue(event);
      this.otpValid = true
    } else {
      this.otpValid = false
    }
  }
  resendOtp() {
    this.signUpService.generateOtp({ phone: Number(this.userData.number ? this.userData.number : this.userData.phone) }, this.userData.dialCode).subscribe((res) => {
      if (res) {
        this.resendOtpBtn = true;
        this.startCountdown(60)
      }
    })
  }
  startCountdown(seconds: any) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter < 10) {
        if (this.counter == 0) {
          console.log(this.counter)
          this.resendOtpBtn = false;
          clearInterval(interval);
          document.getElementById('resend-otp')?.focus()
        }
        this.counter = '0' + this.counter
      }
    }, 1000); //for accurate reading, adjust this value to 980-996
  }
  verifyOtp() {
    let userData = JSON.parse(localStorage.getItem('logData'))
    let payload = {
      countryCode: this.userData.dialCode, 
      phone: this.userData.number ? this.userData.number : this.userData.phone, 
      otp: this.otpForm.value.otp, 
      register: false,
      userActivityTrackingDataDto: !this.sendTrackAPIOnSignInOrSignUp 
      ? undefined 
      : {
        "data": {...(userData||{}), page: 'COURSE_REGISTRATION_OTP_BEFORE_PAYMENT'},
        "landingPage": "COURSE_REGISTRATION_OTP_BEFORE_PAYMENT"
      },
    };
    this.signUpService.validateOtp(payload).subscribe((data) => {
      if (data) {
        setLoggedInUserData(data, this.userService, this.authService);
        console.log(this.navExtras)
        if(!this.sendTrackAPIOnSignInOrSignUp ) {
          isUserAdmin(this.userService).then((bool) => {
            if(!bool) {
              this.userService.callTrackingAPI(data?.userDto?.userId, {data: {...(userData||{}), page: 'COURSE_REGISTRATION_OTP_BEFORE_PAYMENT'}}).subscribe(() => {});
            }
          })
        }
        this.gaService.webEngageEvent(
          {
            'event': 'Registration Started' ,
            'page_url': `https://student.infinitylearn.com/courses/registration?courses=${userData.examName}&batchid=${userData.batchid}&grade=${userData.grade}`,
            'course': userData.examName,
            'grade': userData.grade,
            'batchid': userData.batchid,
            'name':`${userData.firstName}  ${userData.lastName}`,
            'phone': userData.phone,
            'email': userData.email,
            'state':userData.state?.name,
          })
        this.router.navigate(['/courses/payment'], { state: this.navExtras })
      }
    })
  }
}
